export default {
    "msg": {
        "8": "8",
        "20": "20",
        "250": "250",
        "Enter a new password": "Geben Sie ein neues Kennwort ein",
        "Empty": "空",
        "No data": "Keine Daten",
        "Installation Package List": "Liste der Installationspakete",
        "Update Package": "Aktualisierungspaket",
        "Settings - Profiles": "Einstellungen - Profile",
        "User Management": "Benutzerverwaltung",
        "Operation Records": "Betriebsprotokolle",
        "Exit": "Beenden",
        "Total pages:": "Seiten gesamt:",
        "page": "seite",
        "Go to": "Gehe zu",
        "Prev": "Zurück",
        "Next": "Weiter",
        "per page": "Jede Seite",
        "items": "Artikel",
        "Please enter the page number to go to": "请输入前往页数",
        "Language": "Sprache",
        "Profile Picture": "Profilbild",
        "Old Password": "Altes Kennwort",
        "New Password": "Neues Kennwort",
        "Confirm Password": "Kennwort bestätigen",
        "The two passwords entered do not match": "Die beiden eingegebenen Kennwörter stimmen nicht überein",
        "Enter the new password again": "Geben Sie das neue Kennwort erneut ein.",
        "This must match the new password above": "Es muss mit dem oben eingegebenen neuen Kennwort übereinstimmen.",
        "Invalid input。Password length must be 8–16 characters": "Ungültige Eingabe. Das Kennwort muss 8 bis 16 Zeichen lang sein",
        "Lenovo Privacy Statement": "die Lenovo Datenschutzerklärung",
        "Lenovo Software License Agreement": "Lenovo Software-Lizenzvereinbarung",
        "Third-party notifications": "Benachrichtigung Dritter",
        "Third-party notifications": "Benachrichtigungen von Drittanbietern",
        "Change Password": "Kennwort ändern",
        "Edit Profile": "Profil bearbeiten",
        "Exited successfully": "Erfolgreich beendet",
        "Admin": "Verwalter",
        "Common user": "Allgemeiner Benutzer",
        "Super Admin":"Superverwalter",
        "Model": "Modell",
        "Are you sure you want to delete this?": "Möchten Sie dies wirklich löschen?",
        "Enter a new password。It must include at least three of the following：uppercase letters，lowercase letters，numbers，and special characters": "Es muss mindestens drei der folgenden Zeichen enthalten: Großbuchstaben, Kleinbuchstaben, Zahlen und Sonderzeichen.",
        "It must include at least three of the following: uppercase letters, lowercase letters, numbers, and special characters": "Geben Sie ein neues Kennwort ein.Es muss mindestens drei der folgenden Zeichen enthalten: Großbuchstaben, Kleinbuchstaben, Zahlen und Sonderzeichen.",
        "Tip": "Tipp",
        "Confirm": "Bestätigen",
        "Cancel": "Abbrechen",
        "Deletion successful": "Löschen erfolgreich abgeschlossen",
        "Password changed successfully": "Kennwort erfolgreich geändert",
        "The file to upload is larger than 100 MB。 Please select another one。": "Die hochzuladende Datei ist größer als 100 MB. Bitte wählen Sie eine andere Datei aus.",
        "Your session has expired。 Please log in again。": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
        "Invalid network request URL": "Ungültige Netzwerkanforderungs-URL.",
        "Unknown server error": "Unbekannter Serverfehler.",
        "An unknown error has occurred": "Ein unbekannter Fehler ist aufgetreten!",
        "Request timeout Please check your network and try again": "Zeitüberschreitung der Anforderung. Überprüfen Sie Ihr Netzwerk und versuchen Sie es erneut.",
        "Failed to connect to server": "Herstellen einer Verbindung zum Server fehlgeschlagen",
        "Your network may be currently disconnected": "Möglicherweise ist Ihre Netzwerkverbindung zurzeit getrennt",
        "No related device found": "Kein entsprechendes Gerät gefunden",
        "Pre-upgrade component not found in the device": "Voraktualisierte Komponenten im Gerät nicht gefunden",
        "FWID of the installation component not found": "FWID der Installationskomponente nicht gefunden",
        "Failed to set upgrade information": "Aktualisierungsinformationseinstellungen fehlgeschlagen",
        "Failed to set specified update options": "Angabe der Aktualisierungseinstellungen fehlgeschlagen",
        "Failed to install the update package": "Angabe der Aktualisierungseinstellungen fehlgeschlagen",
        "Failed to obtain the device handle": "Abrufen des Gerätehandles fehlgeschlagen",
        "Upgrade device mismatch": "Das Upgrade-Gerät passt nicht",
        "Installation failed: Pre-upgrade component not found in the device": "Installation nicht möglich: Keine Voraktualisierungskomponente auf dem Gerät gefunden",
        "Installation failed: FWID mismatch in the component list": "Installation nicht möglich: FWID in der Komponente stimmt nicht überein",
        "Installation failed: No matching monitor found for upgrade": "Installation nicht möglich: kein Monitor für das Upgrade gefunden",
        "The monitor does not exist": "Der Monitor ist nicht vorhanden",
        "The command has been sent": "Der Befehl wurde gesendet",
        "The group does not exist": "Die Gruppe ist nicht vorhanden",
        "The command does not exist": "Der Befehl ist nicht vorhanden",
        "Setting does not exist": "Einstellungen existieren nicht",
        "The settings profile does not exist": "Das Einstellungsprofil ist nicht vorhanden",
        "The update package does not exist": "Das Aktualisierungspaket ist nicht vorhanden",
        "The update package record does not exist": "Der Datensatz des Aktualisierungspakets ist nicht vorhanden",
        "Invalid password format。 It must be between 8 and 30 characters long。": "Ungültiges Kennwortformat. Es muss zwischen 8 und 30 Zeichen lang sein.",
        "Password format is incorrect, password must include at least three types of the following: uppercase letters, lowercase letters, digits, and special characters": "密码格式不正确，密码至少包含大写字母、小写字母、数字和特殊字符中的三种类型",
        "The field is empty": "Das Feld ist leer",
        "Update time cannot be null": "Die Upgrade-Zeit kann nicht leer sein.",
        "Invalid update time。 It cannot be earlier than the current time or more than 30 days in the future。": "Ungültige Aktualisierungszeit. Sie darf nicht vor der aktuellen Uhrzeit und nicht mehr als 30 Tage in der Zukunft liegen.",
        "Uploaded file is null": "上传文件为空",
        "Uploaded file format is incorrect， file format can only be zip/exe/dmg/app": "Das hochgeladene Dateiformat ist falsch, das Dateiformat kann nur zip/exe/dmg/app sein",
        "Uploaded file format is incorrect， file cannot have no extension": "Datei im falschen Format hochgeladen, Datei kann nicht ohne Suffix",
        "Login failed。 Make sure you entered the correct account ID and password。": "Anmeldung fehlgeschlagen. Vergewissern Sie sich, dass Sie die richtige Konto-ID und das richtige Kennwort eingegeben haben.",
        "Date": "das",
        "Time": "die",
        "The data will be permanently deleted": "Diese Aktion löscht die aktuellen Daten dauerhaft, ob sie fortgesetzt werden?",
        "Please select an item to delete first": "Bitte wählen Sie einen Eintrag aus, bevor Sie ihn löschen.",
        "Begin Download": "Starten Sie den Download",
        "Start Download":"Download starten",
        "Password incorrect": "Kennwort falsch",
        "Password Changed Successfully": "Passwort erfolgreich geändert",
        "Display ID or Group ID is empty": "Display-ID oder Gruppen-ID ist leer",
        "Select the update package": "Wählen Sie das Aktualisierungspaket aus",
        "Username already exists": "Der Benutzername existiert bereits",
        "Executing monitor setting command。Please wait 10s before making new changes。": "Der Befehl zur Einstellung des Monitors wird ausgeführt, warten Sie 10 Sekunden, bevor Sie eine neue Einstellung durchführen",
     
        "Close": "Aus",
        "Role does not exist。 Cannot modify role。": "Die Rolle existiert nicht und kann nicht geändert werden.",
        "Unknown Command": "Unbekannter Befehl",
        "Access Token Expired": "Zugriffstoken sind abgelaufen",
        "Invalid Refresh Token": "Ungültiges Aktualisierungstoken",
        "Missing Request Parameters:": "Abfrageparameter fehlen:",
        "Incorrect Request Parameter Type:": "Fehler Typ des Anforderungsparameters:",
        "Request URL Not Found:": "Die angeforderte Adresse existiert nicht:",
        "Incorrect Request Method:": "Anforderungsmethode ist falsch:",
        "Log In": "Anmelden",
        "account ID": "Kontonummer",
        "password": "Passwort",
        "Update failed": "Aktualisierung fehlgeschlagen",
        "Reset Password?": "Kennwort zurücksetzen",
        "Logged in successfully": "Erfolgreich angemeldet",
        "Please contact the system administrator to reset your password": "Wenden Sie sich an den Systemadministrator, um Ihr Kennwort zurückzusetzen.",
        "Retry limit exceeded。 Please try again after 30 minutes": "Versuchen Sie es mehr als 5 Mal erneut, bitte in 30 Minuten erneut.",
        "Enter the model / host name / firmware version number": "Geben Sie Modell / Hostname / Firmware-Versionsnummer ein",
        "New Group": "Neue Gruppe",
        "Delete Group": "Gruppe löschen",
        "Display Columns": "Spalten anzeigen",
        "Collapse": "Reduzieren",
        "Expand": "Erweitern",
        "Move To": "Verschieben nach",
        "Export": "Exportieren",
        "Power On": "Einschalten",
        "Power Off": "Ausschalten",
        "Screen lock": "Bildschirmsperre",
        "Unlock screen": "Bildschirm entsperren",
        "Settings": "Einstellungen",
        "Export Settings Profiles": "Einstellungsprofile exportieren",
        "Update": "Aktualisieren",
        "Delete Monitor": "Monitor löschen",
        "Total devices": "Geräte gesamt",
        "Selected devices": "Ausgewählte Geräte",
        "Update package name": "Name des Aktualisierungspakets",
        "Update Time": "Aktualisierungszeitpunkt",
        "Apply to all displays of the same model": "Für das gleiche Display-Modell",
        "Display Settings": "Anzeigeeinstellungen",
        "Select All": "Alle auswählen",
        "Settings Profiles": "Einstellungsprofile",
        "Filename": "Dateiname",
        "Group": "Gruppe",
        "Monitor Model": "Monitor-Modell",
        "Special ID": "Spezielle ID",
        "Host Name": "Hostname",
        "Host Status": "Hoststatus",
        "Monitor Status": "Monitorstatus",
        "Lock Status": "Sperrstatus",
        "Update Progress": "Aktualisierungsfortschritt",
        "Settings Profile": "Einstellungsprofil",
        "Tips": "Tipps",
        "Active Time": "Aktive Zeit",
        "Overclock": "超频",
        "Operation successful": "Vorgang erfolgreich abgeschlossen",
        "Please save data": "Bitte speichern Sie die Daten",
        "Select the data first": "Wählen Sie zuerst die Daten aus",
        "Cannot modify when ungrouped": "Ändern nicht möglich, wenn nicht gruppiert",
        "Deselect All": "Alle abwählen",
        "Select the GAMMA node label value": "Wählen Sie den Wert für die GAMMA-Knoten-Beschriftung aus",
        "Ungrouped": "Nicht gruppiert",
        "Offline": "Offline",
        "Online": "Online",
        "Power on": "Starten",
        "Power off": "Ausschalten",
        "Locked": "Verschlossen",
        //"Open": "Nicht gesperrt",
        "Open": "Aufgeschlossen",
        "Unlocked":"Aufgeschlossen",
        "Not connected": "Nicht verbunden",
        "Connected": "Verbinden",
        "Set the update start time": "Legen Sie die Startzeit der Aktualisierung fest",
        "Now": "Jetzt",
        "Set upgrade mode": "Aktualisierungsmodus einrichten",
        "Interactive Mode": "Interaktiver Modus",
        "Silent mode": "Stiller Modus",
        "In this mode， a monitor firmware update screen will appear and request users confirmation to proceed! Users may choose to postpone the update twice, after which the update will be enforced": "In diesem Modus wird ein Bildschirm zur Aktualisierung der Monitor-Firmware angezeigt, auf dem der Benutzer aufgefordert wird, die Fortsetzung des Vorgangs zu bestätigen. Benutzer können die Aktualisierung zweimal verschieben, danach wird die Aktualisierung obligatorisch durchgeführt.",
        "In this mode， when the monitor is online， the firmware update will be automatically performed in the background。 Users will not see any notifications。 The update will take effect when the display is restarted。 The restart of the monitor takes about a few seconds， and won’t affect any ongoing tasks on your computer。": "in diesem Modus wird die Firmware-Aktualisierung automatisch im Hintergrund durchgeführt, sobald der Monitor online ist. Den Benutzern werden keine Benachrichtigungen angezeigt. Die Aktualisierung wird wirksam, wenn der Monitor neu gestartet wird. Der Neustart des Monitors dauert einige Sekunden und hat keine Auswirkungen auf laufende Aufgaben auf Ihrem Computer.",
        "Invalid input": "Ungültige Eingabe",
        "Failed to log in": "Anmeldung fehlgeschlagen",
        "Select your preferred restart time。": "Wählen Sie den bevorzugten Zeitpunkt für den Neustart im Einklang mit Ihrer Nutzung aus.",
        "You have still selected the group that the device currently belongs to。 If you want to move the device， please select another group。": "您点击的仍是设备现属组，若要移动，请选其他组。",
        "Enter the group name": "Geben Sie den Gruppennamen ein",
        "Apply profile:": "Profil anwenden:",
        "A new version is available": "Eine neue Version ist verfügbar",
        "Restart monitor immediately after update": "Monitor sofort nach Update neu starten",
        "Restart when the monitor enters sleep mode": "Neu starten, wenn der Monitor in den Energiesparmodus wechselt",
        "Restart monitor when it disconnected from all PCs": "Neustart, wenn der Monitor getrennt und alle PC-Verbindungen",
        "Enter the model name": "Geben Sie den Modellnamen ein",
        "Create Update Task": "Aktualisierungsaufgabe erstellen",
        "Update Task List": "Aufgabenliste aktualisieren",
        "Cancel All": "Alles abbrechen",
        "View Details": "Details anzeigen",
        "Update Details": "Details zur Aktualisierung",
        "Update Mode": "Aktualisierungsmodus",
        "Update Creation Time": "Erstellungszeitpunkt der Aktualisierung",
        "Update Start Time": "Startzeit der Aktualisierung",
        "Are you sure you want to cancel all tasks?": "Möchten Sie wirklich alle Aufgaben abbrechen?",
        "Are you sure you want to cancel this task?": "Möchten Sie diese Aufgabe wirklich abbrechen?",
        "Are you sure you want to delete the selected monitor?": "Möchten Sie den ausgewählten Monitor wirklich löschen?",
        "Confirm to delete all displays?": "Sind Sie sicher, dass Sie alle Monitore löschen möchten?",
        "Are you sure you want to delete this？（Cannot delete when ungrouped）": "Möchten Sie dies wirklich löschen? (Löschen nicht möglich, wenn nicht gruppiert)",
        "Tip: If an option in the display settings appears grayed out， it may be restricted by another setting。 Try adjusting other settings to remove the restriction。": "Tipp: Wenn eine Option in den Anzeigeeinstellungen abgeblendet angezeigt wird, ist sie eventuell durch eine andere Einstellung eingeschränkt. Versuchen Sie, andere Einstellungen anzupassen, um die Einschränkung aufzuheben.",
        "The WebSocket connection has been restored": "Die WebSocket-Verbindung wurde wiederhergestellt.",
        "The previous setting is currently being applied。 Please wait until the value changes before making any new settings。": "上一设置正在执行中，请等待数值变化后，再进行新的设置",
        "Please copy this password into the input box: ": "Kopieren Sie dieses Kennwort in das Eingabefeld: ",
        "Ebook": "E-Buch",
        "largest": "größte",
        "Max": "Max.",   
        "Turn off auto mode": "Auto-Modus ausschalten",
        "Minimum": "Minimal",
        "Restore Factory Settings": "Werkseinstellungen wiederherstellen",
        "Scenario Mode": "Szenario-Modus",
        "Color Gamut & Color Temperature": "Farbraum & Farbtemperatur",
        "Panel Native": "Native Einstellung anzeigen",
        "Close PIP, PBP":"Schließen",
        "PIP window":"PIP",
        "PBP window":"PBP",
        "Neutral": "Neutral",
        "Neutral(7500K)":"Neutral",
        "Reddish(6500K)":"Rotisch(6500K)",
        "Bluish(9300K)":"Warm",
        "Warm": "Varm",
        "Cool": "Kühl",
        "Low Blue Light": "Niedriges Blaulicht",
        "Custom 1": "Benutzerdefiniert 1",
        "Custom 2": "Benutzerdefiniert 2",
        "Custom 3": "Benutzerdefiniert 3",
        "BT.709": "BT.709",
        "BT.2020": "BT.2020",
        "Video Signal": "Video-Signal",
        "Game Mode": "Spiel-Modus",
        "Off": "Schließen",
        "Game 1": "Spiel 1",
        "Game 2": "Spiel 2",
        "Response Time": "Reaktionszeit",
        "Normal": "Normal",
        "Extreme": "Extrem",
        "Level 1": "Stufe 1",
        "Level 2": "Stufe 2",
        "Level 3": "Stufe 3",
        "Level 4": "Stufe 4",
        "Level 5": "Stufe 5",
        "Lan Indicator": "LAN Indikator",
        "Linked": "verbunden",
        "No Link": "nicht verbunden",
        "Blinking": "in Kommunikation",
        "Brightness": "Kontrast",
        "Contrast": "Helligkeit",
        "Smart Light": "intelligente Beleuchtung",
        "Volume Control": "Lautstärkeregler",
        "USB Select": "USB-Auswahl",
        "DP Select": "DP Auswählen",
        "Aspect Ratio": "Seitenverhältnis",
        "Smart Traffic Light": "Intelligente Ampel",
        "daisy chain": "Daisy Chain",
        "Dynamic Contrast": "Dynamischer Kontrast",
        "Smart Energy": "Intelligente Energiesteuerung",
        "Smart Audio": "Intelligente Audiotechnik",
        "Distance Warning": "Abstandswarnung",
        "Ambient Light Detection": "Umgebungslichterkennung",
        "Enabled Ambient Light Detection": "Umgebungslichterkennung aktivieren",
        "enabled":"aktivieren",
        "disabled":"disabled",
        "Waken on Touch": "Wake-on-Touch-Funktion",
        "True Split": "Wahre Aufteilung",
        "Face Tracking": "Gesichtsverfolgung",
        "Audio Smart Switch": "Audio Smart Switch",
        "Auto-alarm": "Auto-alarm",
        "KVM Switch": "KVM-Umschalter",
        "KVM切换": "KVM-Umschalter",
        "KVM(Keyboard, Video, Mouse) Switch enables two PCs to use one set of monitor, keyboard and mouse, Enable switching video, keyboard and mouse simultaneously. If disabled, only switch keyboard and mouse.": "KVM(Keyboard, Video, Mouse)-Umschalter ermöglicht zwei PCs die Verwendung eines Satzes von Monitor, Tastatur und Maus, Ermöglichen das gleichzeitige Umschalten von Video, Tastatur und Maus. Wenn deaktiviert, nur Tastatur und Maus umschaltbar",
        "Sitting Reminder": "Bewegungserinnerung",
        "Gaming": "Spielmodus",
        "RGB Gain": "Farbabstimmung",
        "Serial No": "Seriennummer",
        "Firmware Version": "Firmware-Version",
        "Select response time level": "Ansprechzeitstufe auswählen",
        "Enable daisy chain": "Daisy Chain aktivieren",
        "Smart Traffic Light is a do not disturb light, helping to reduce distraction": "Intelligente Ampel ist ein nicht störendes Licht, das zur Verringerung der Ablenkung beiträgt",
        "Enable/Disable the Audio Smart function": "Audio-Smart-Funktion aktivieren/deaktivieren",
        "Auto-alarm indicates whether the camera/MIC on monitor is in use": "Auto-alarm zeigt an, ob die Kamera/das Mikrofon auf dem Monitor in Betrieb ist",
        "Enable Distance Warning": "Abstandswarnung aktivieren",
        "Enable/disable face tracking": "Gesichtsverfolgung aktivieren/deaktivieren",
        "Enable Sitting Reminder": "Bewegungserinnerung aktivieren",
        "Smart Audio technology allows you to focus on the sound in front of you to improve voice clarity": "Die Intelligente Audiotechnik ermöglicht es Ihnen, sich auf den Klang vor Ihnen zu konzentrieren, um die Klarheit der Stimme automatisch zu verbessern",
        "Smart Energy technology automatically manages energy consumption by human detection sensor": "Die intelligente Energiespartechnologie kontrolliert den Energieverbrauch automatisch durch den Menschen-Erkennungssensor",
        "Implement PBP through only one cable": "PBP über nur ein Kabel implementieren",
        "Enable/Disable vPro technology in the monitor": "Aktivieren/Deaktivieren der vPro Technologie im Monitor",
        "Wake system by touch": "System durch Berühren aufwecken",
        "Set video source and USB source (used by keyboard and mouse) for every PC": "Videoquelle und USB-Quelle (verwendet von Tastatur und Maus) für jeden PC einstellen",
        "eKVM gives you instant access over two PC sources with a 2-button pressing of your mouse": "eKVM ermöglicht durch Drücken von zwei Tasten mit der Maus zum Zugreif sofort auf zwei PC-Quellen",
        "Enable USB charging always on": "USB-Ladefunktion immer eingeschaltet",
        "Select DP version": "Wählen Sie DP Version",
        "USB Charging": "USB-Ladung",
        "PC": "PC",
        "Double-click the CTRL": "Doppelklicken Sie auf die STRG-Taste",
        "Full Screen": "Vollbildschirm",
        "Original AR": "Original AR",
        "No scaling": "Keine Skalierung",
        "on": "Öffnen",
        "On": "Öffnen",
        "Keyboard On": "Tastatur anwenden",
        "Mouse On": "Maus anwenden",
        "Image Creation": "Bild-Erstellung",
        "Digital Cinema": "Digitales Kino",
        "Video Creation": "Video-Erstellung",
        "Web Browsing": "Web-Browsing",
        "Professional Image": "professionelles Image",
        "DisplayPort": "DisplayPort",
        "Auto": "Automatisch",
        "Refresh": "Aktualisieren",
        "Search": "Suchen",
        "Record": "Datensatz",
        "Username": "Benutzername",
        "Upload Time": "Upload-Zeit",
        "Add Profiles": "Profile hinzufügen",
        "Latest Update Package": "Neuestes Aktualisierungspaket",
        "Upload Update Package": "Aktualisierungspaket hochladen",
        "Upload": "Hochladen",
        "Size": "Größe",
        "Upload successful": "Hochladen erfolgreich abgeschlossen",
        "Download successful": "Download erfolgreich abgeschlossen",
        "Refresh successful": "Aktualisierung erfolgreich abgeschlossen",
        "The upgrade package does not match the device model": "Das Upgrade-Paket passt nicht zum Modell",
        "Upgrade package does not match the device model":"Das Upgrade-Paket stimmt nicht mit dem Gerätemodell überein",
        "Please enter the setting name": "Bitte geben Sie den Namen der Einstellung ein",
        "Edit": "Bearbeiten",
        "Save": "Speichern",
        "Delete": "Löschen",
        "Add": "Hinzufügen",
        "Reset Password": "Kennwort zurücksetzen",
        "No": "Nr.",
        "Full Name": "Vollständiger Name",
        "Role": "Rolle",
        "Creation Date": "Erstellungsdatum",
        "Operation": "Vorgang",
        "Actions": "Vorgang",
        "The user's initial password is ": "Das ursprüngliche Passwort des Benutzers ist",
        "The password has been reset to：": "Das Kennwort wurde zurückgesetzt auf: ",
        "Invalid input。Usernames can only contain numbers and letters。": "Ungültige Eingabe. Der Benutzername besteht aus Zahlen und Buchstaben.",
        "Invalid input。The username must contain 4 to 30 characters。": "Ungültige Eingabe. Der Benutzername muss 4 bis 30 Zeichen lang sein.",
        "Installation Package": "Installationspaket",
        "Operation Date": "Datum des Vorgangs",
        "Actions": "Aktionen",
        "Operator": "Bediener",
        "Paging component": "Paging Komponente",
        "Quick page flipping": "Schnelles Seitenflippen",
        "Current page": "Aktuelle Seite",
        "Title": "Titel",
        "Details": "Details",
        "This is the expanded area": "Dies ist der erweiterte Bereich",
        "Set Display Column": "Anzeige Spalte festlegen",
        "Upload file": "Datei hochladen",
        "Drop-down to expand": "Drop-Down zum Erweitern",
        "Default": "Standardeinstellung",
        "Default Info": "Standardinformationen",
        "Personal Center": "Persönliches Zentrum",
        "Personal center image button": "Persönliche Bildschaltfläche im Zentrum",
        "Expandable area": "Erweiterbare Fläche",
        "Update Package Table": "Pakettabelle aktualisieren",
        "This is the table header": "Dies ist der Tabellenkopf",
        "This is the table content": "Dies ist der Inhalt der Tabelle",
        "UserList Table": "Benutzerliste Tabelle",
        "Page Up and Down": "Seite oben und unten",
        "Operation record table": "Tabelle der Betriebsregistrierung",
        "OSD upgrade details": "Details zum OSD-Upgrade",
        "Lenovo": "Lenovo",
        "Display Fleet Manager": "Display Fleet Manager",
        "HDR": "HDR",
        "eKVM": "eKVM",
        "Video": "Video",
        "Data": "Data",
        "vPro": "vPro",
        "Gama": "Gama",
        "PIP/PBP": "PIP/PBP",
        "OSD": "OSD",
        "USB-C Charging": "USB-C-Laden",
        "PIP": "PIP",
        "PBP": "PBP",
        /*
        "Simplified Chinese": "Chinesisch vereinfacht",
        "English": "Englisch",
        "Traditional Chinese": "Traditionelles Chinesisch",
        "French": "Französisch",
        "German": "Deutsch",
        "Italian": "Italienisch",
        "Spanish": "Spanisch",
        "Japanese": "Japanisch",
        "Thai": "Thailändisch",
        "Ukrainian": "Ukrainisch",
        "Russian": "Russisch",
        */
        "Enter your account ID": "Geben Sie Ihre Konto-ID ein",
        "Please Enter your account id":"Wenden Sie sich an den Systemadministrator, um Ihr Kennwort zurückzusetzen.",
        "Enter your password": "Geben Sie Ihr Kennwort ein",
        "Cannot exceed 20 characters": "Darf nicht länger als 20 Zeichen sein",
        "Enter the original password": "Geben Sie das ursprüngliche Kennwort ein",
        "You have still selected the group that the device currently belongs to. If you want to move the device, please select another group. ": "Sie haben noch die Gruppe ausgewählt, zu der das Gerät derzeit gehört. Wenn Sie das Gerät verschieben möchten, wählen Sie eine andere Gruppe aus. ",
        "Enter the filename": "Geben Sie dateiname ein",
        "Update Package Name": "Name des Aktualisierungspakets",
        "Select the date": "Wählen Sie das Datum aus",
        "Select the time": "Wählen Sie die Uhrzeit aus",
        "Set the update mode": "Den Aktualisierungsmodus festlegen",
        "Restart when the monitor is not connected to any computer": "Neu starten, wenn der Monitor nicht an einen Computer angeschlossen ist",
        "Invalid file format": "Ungültiges Dateiformat. Nur zip/exe/dmg/app-Dateien werden unterstützt.",
        "Select a valid file type": "Wählen Sie einen gültigen Dateityp aus",

        "The data is being processed。 Please do not submit again。": "Die Daten werden verarbeitet. Bitte nicht erneut senden.",
        "Enter the profiles name": "Geben Sie den Profilnamen ein",
        "Enter your username": "Geben Sie Ihren Benutzernamen ein",
        "Enter your full name": "Geben Sie Ihren vollständigen Namen ein",
        "The initial password of this user is:": "Das anfängliche Kennwort dieses Benutzers lautet: ",
        "Select your role": "Wählen Sie Ihre Rolle aus",
        "User Profile": "Benutzerprofil",
        "Downloading": "Herunterladen...",
        "Enter the new password again。Two times of new password input is same": "Geben Sie das neue Kennwort erneut ein.Das neue Kennwort muss mit der vorherigen Eingabe übereinstimmen.",
        "Request failed with status code 502": "Anfrage fehlgeschlagen mit Statuscode 502",
        "Please Enter your x": "Geben Sie {param} ein",
        "Select the x": "Wählen Sie {param} aus",
        "Please select the correct file type x": "Wählen Sie einen gültigen Dateityp aus{param}",
        "Please select the correct file type": "Wählen Sie einen gültigen Dateityp aus",
        "Input characters within x characters": "Geben Sie Zeichen innerhalb von {param} Zeichen ein",

        "Monitor List":"Monitorliste",
        "List of update packages":"Liste der Aktualisierungspakete",
        "Settings - Profiles":"Einstellungen - Profile",
        "User Management":"Benutzerverwaltung",
   

        "Simplified Chinese": "简体中文",
        "English": "English",
        "Traditional Chinese": "繁體中文",
        "French": "Français",
        "German": "Deutsch",
        "Italian": "Italiano",
        "Spanish": "Español",
        "Japanese": "日本語",
        "Thai": "ภาษาไทย",
        "Ukrainian": "Українська",
        "Russian": "Русский язык",

        "System abnormality":"Systemabweichung",

        "Upgrade Package Record ID is empty":"Wählen Sie das Aktualisierungspaket aus",
        "Invalid update time。 It cannot be earlier than the current time or more than 30 days in the future。":"Ungültige Aktualisierungszeit. Es kann nicht früher als die aktuelle Zeit oder mehr als 30 Tage in der Zukunft sein.",

        "Request parameter is invalid:The username must contain 4 to 30 characters。":"Anforderungsparameter ist ungültig:Der Benutzername muss 4 bis 30 Zeichen enthalten.",
        "The WebSocket connection has been lost Reconnecting":"Die WebSocket-Verbindung ist verloren gegangen",
        "Request parameter is invalid：Usernames can only contain numbers and letters。":"Der Anforderungsparameter ist ungültig: Der Benutzername besteht aus Zahlen und Buchstaben.",
   
        "Request parameter is invalid:Password length must be between 8-16 character":"Anforderungsparameter ist ungültig: Passwortlänge muss zwischen 8-16 Zeichen liegen.",
        "The compiled package is missing: the component has a corresponding bin that has not been uploaded。Please upload it before compiling":"Das kompilierte Paket fehlt: Die Komponente hat einen entsprechenden Bin, der nicht hochgeladen wurde. Bitte laden Sie es vor der Kompilierung hoch.",

        "Request parameter is invalid：Password length must be 8–16 characters":"Anforderungsparameter ist ungültig:Passwortlänge muss zwischen 8-16 Zeichen liegen",
      

        "Illegal request header!": "Unzulässiger Anforderungsheader!",
        "Invalid request parameters":"Ungültige Anforderungsparameter",

        "Export": "Exportieren",
        "It is already a high-version and there is no need to upgrade":"Es ist bereits eine High-Version und es ist kein Upgrade erforderlich",
        "Repeated request， please try again later":"Repeated request, please try again later",
        "Communication":"Kommunikation"
    }
}